import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import axios from 'axios';
import VeeValidate from 'vee-validate';
import { TweenLite, TimelineLite, CSSRulePlugin } from 'gsap/all'
import routes from './routes/routes';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/scss/bootstrap-grid.scss';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/scss/_style.scss';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import locale from 'element-ui/lib/locale/lang/en'
import store from './store';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ElementUI, { locale });
Vue.use(VueRouter);
Vue.use(axios);
Vue.use(VeeValidate);

const router = new VueRouter({
  routes,
});

Vue.config.productionTip = false

const activated = [
  TweenLite,
  TimelineLite,
  CSSRulePlugin,
];
  
Vue.prototype.TweenLite = TweenLite;
Vue.prototype.TimelineLite = TimelineLite;
Vue.prototype.CSSRulePlugin = CSSRulePlugin;

new Vue({
  activated,
  store,
  router,
  render: h => h(App),
}).$mount('#app')
